"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataMetricService = void 0;
const _ = require("lodash");
const common_1 = require("@angular/common");
const data_source_service_1 = require("./data-source.service");
//ANGULAR2 BITS
const core_1 = require("@angular/core");
//INTERNAL LIBRARY BITS
const notification_service_1 = require("./notification.service");
//EXTERNAL LIBRARY BITS
const token_service_1 = require("./token.service");
let DataMetricService = class DataMetricService {
    constructor(_http, _dataSource, _talk, _decimalPipe, _datePipe) {
        this._http = _http;
        this._dataSource = _dataSource;
        this._talk = _talk;
        this._decimalPipe = _decimalPipe;
        this._datePipe = _datePipe;
        //declarations
        this.dataMetrics = [];
        //initializations
        this.dataMetricURL = "/datametric";
        this.AD_SERVER = 'adServer';
        this.BIDDR_360 = 'biddr360Data';
    }
    pull(dataSourceSlug) {
        const sourceSlug = dataSourceSlug || this._dataSource.getCurrentSource().slug;
        const source = sourceSlug || (this._dataSource.get()[0]) ? this._dataSource.get()[0].slug : null;
        if (source) {
            return Promise.resolve(this._dataSource.getMetrics(source));
        }
        return Promise.reject(new Error('No Data Source Found'));
    }
    get() {
        const currentSource = this._dataSource.getCurrentSource();
        let metrics = (currentSource && currentSource.dataMetrics) ? currentSource.dataMetrics : [];
        // Only use priority for biddr connect - will use for all eventually 
        if (currentSource.isConnect()) {
            metrics = _.sortBy(metrics, m => m.priority);
        }
        return metrics;
    }
    isValidSourceMetric(metricSlug) {
        return this.get().findIndex(m => m.slug === metricSlug) >= 0;
    }
    getNonGroupingMetrics() {
        return this.get().filter(m => !m.groupingKey && !m.groupingMetric);
    }
    getGroupingMetrics() {
        return this.get().filter(m => !!m.groupingKey);
    }
    getGroupingMetricsAux() {
        return this.get().filter(m => !!m.groupingMetric);
    }
    filterMetricsThatExistOn(metrics, values = {}) {
        return metrics.filter(m => (values && typeof values[m.slug] !== 'undefined'));
    }
    getGroupingMetricsKeys() {
        return this.getGroupingMetrics().map(m => m.slug);
    }
    getWeightedMetrics() {
        return this.get().filter(m => (m.config && m.config.weighted));
    }
    ;
    getWeightedMetricsKeys() {
        return this.getWeightedMetrics().map(m => m.slug);
    }
    ;
    getVisible() {
        return this.dataMetrics.filter(val => { return val.visible; });
    }
    getHidden() {
        return this.dataMetrics.filter(val => { return !val.visible; });
    }
    setSingleVisibility(metric, vis = true) {
        let metricToMakeVisible = this.dataMetrics.find(dM => dM.slug == metric);
        if (metricToMakeVisible) {
            metricToMakeVisible.visible = vis;
        }
    }
    setAllVisibility(vis = true) {
        this.dataMetrics = this.dataMetrics.map(v => { v.visible = vis; return v; });
    }
    getVisibleFilterColumns() {
        let visibleMetrics = this.getVisible();
        if (visibleMetrics.length > 0) {
            return '&col=' + visibleMetrics.map(val => { return val.slug; }).join('&col=');
        }
        else
            return '';
    }
    formatMetricValue(value, metricConfig, useClientSide = true) {
        return (useClientSide && metricConfig && metricConfig.clientFormat)
            // Note: When ready we can use IntlNumber formatter // with formats from metricConfig.format
            ? this.clientSideMetricFormatter(value, metricConfig.clientFormat)
            : value;
    }
    initMetricsFormatters(dataMetrics) {
        return dataMetrics.reduce((formatters, metric) => {
            formatters[metric.slug] = metric.config ? v => this.formatMetricValue(v, metric.config) : v => v;
            return formatters;
        }, {});
    }
    clientSideMetricFormatter(value, formatOpts) {
        let formattedValue = value;
        if (formatOpts.roundTo)
            formattedValue = this._decimalPipe.transform(value, formatOpts.roundTo);
        if (formatOpts.dateFormat) {
            // Note: tz_datehour values are already in user timezone from backend, 
            // so we should NOT apply .utc() conversion again
            formattedValue = this._datePipe.transform(moment(value).format('MM/DD/YY HH:mm'), formatOpts.dateFormat);
        }
        if (formatOpts.frontDecorator)
            formattedValue = `${formatOpts.frontDecorator}${formattedValue}`;
        if (formatOpts.backDecorator)
            formattedValue = `${formattedValue}${formatOpts.backDecorator}`;
        return formattedValue;
    }
    isAdServer(metric) {
        return metric.dataType === this.AD_SERVER;
    }
    isBiddr360(metric) {
        return metric.dataType === this.BIDDR_360;
    }
};
exports.DataMetricService = DataMetricService;
exports.DataMetricService = DataMetricService = __decorate([
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [token_service_1.TokenService,
        data_source_service_1.DataSourceService,
        notification_service_1.NotificationService,
        common_1.DecimalPipe,
        common_1.DatePipe])
], DataMetricService);
//# sourceMappingURL=data-metric.service.js.map